import React, { Component } from "react";
import { connect } from "react-redux";
import FontAwesome from "react-fontawesome";
import Immutable from "immutable";

import Modal from '@mawesi-sas/mws_react_component_modal';
import Input from '@mawesi-sas/mws_react_component_input';
import ButtonStrip from "../../Layout/components/ButtonStrip";
import BoxButton from "../../Layout/components/BoxButton";
import TiposProducto from "./TiposProducto";

import {
  showHideModalCreate,
  guardarTipoServicio,
  showHideModalCreateTipoProducto,
  adicionarUsuario
} from "../actions";
import {
  showHideModalSelector,
  selectFromSelector
} from "../../Layout/actions";

class ModalCreate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tabs: [
        {
          id: 0,
          caption: "Tipos de producto",
          component: <TiposProducto />
        }
      ],
      selected: 0
    };
  }

  selectTab = (e, tab) => {
    e.preventDefault();
    this.setState({ selected: tab });
  };

  modalContent = () => {
    const { tabs, selected } = this.state;
    const buttons = [];
    if (this.props.elementos.filter(x => x === "rITU6xmf").count())
      buttons.push(
        <BoxButton
          key="ba[-1][0]"
          name="floppy-o"
          title="Guardar"
          disabled={this.props.saving}
        />
      );

    const tabButtons = [];
    if (this.state.selected === 0) {
      if (this.props.elementos.filter(x => x === "rITU6xmf").count()) {
        tabButtons.push(
          <BoxButton
            key="btn1[2][0]"
            name="plus"
            title="Nuevo tipo de producto"
            onClick={e => {
              e.preventDefault();
              this.props.showHideModalCreateTipoProducto(true);
            }}
          />
        );
      }
    }

    return (
      <form
        id="form"
        onSubmit={e => {
          e.preventDefault();
          this.props.guardarTipoServicio();
        }}
        noValidate
      >
        <ButtonStrip actions={buttons} />
        <div>
          <div className="row">
            <div className="col-md-4">
              <div className="form-group">
                <label className="control-label">Nombre</label>
                <Input
                  type="text"
                  reducer="tiposervicios"
                  path="modalCreate.data.nombre"
                />
              </div>
            </div>
            <div className="col-md-2">
              <div className="form-group">
                <label className="control-label">Estado</label>
                <Input
                  type="select"
                  reducer="tiposervicios"
                  path="modalCreate.data.activo"
                  options={[
                    { caption: "ACTIVO", value: true },
                    { caption: "INACTIVO", value: false }
                  ]}
                />
              </div>
            </div>
          </div>
          <div style={{ marginTop: "15px" }}>
            <div className="row">
              <div className="col-md-12" style={{ height: "250px" }}>
                <div
                  className="row"
                  style={{
                    height: "100%",
                    overflowX: "hidden"
                  }}
                >
                  <div className="col-md-12" style={{ height: "100%" }}>
                    <div className="nav-container">
                      <div className="nav-tabs-section">
                        <ul className="nav-tabs-tabs">
                          {tabs.map(x => {
                            return (
                              <li
                                key={`li02[${x.id}]`}
                                className={selected === x.id ? "active" : ""}
                              >
                                <a onClick={e => this.selectTab(e, x.id)}>
                                  {x.caption}
                                </a>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                      <div className="nav-main-section">
                        <div className="">
                          <ButtonStrip actions={tabButtons} />
                        </div>
                        <div className="nav-main-section-scrollable">
                          {tabs[selected].component}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    );
  };

  render() {
    const { modalCreate } = this.props;
    return (
      <Modal
        ancho="50vw"
        mostrar={modalCreate.get("show")}
        contenido={this.modalContent()}
        titulo="Creacion/Modificacion de tipos de sevicio"
        nombre="modal_create_tiposervicios"
        onCerrarModal={() => this.props.showHideModalCreate(false)}
      />
    );
  }
}

const mapStateToProps = (state, onwProps) => {
  return {
    modalCreate: state.tiposervicios.get("modalCreate"),
    elementos: state.layout.get("elementos")
  };
};

const mapDispatchToProps = {
  showHideModalCreate,
  guardarTipoServicio,
  showHideModalSelector,
  selectFromSelector,
  showHideModalCreateTipoProducto,
  adicionarUsuario
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalCreate);
